import React, { FC } from 'react';
import { Chart, ChartData, ChartOptions, ChartType, Plugin, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ReactChartJs } from 'react-chartjs-2';

Chart.register(...registerables, ChartDataLabels);
// Hide data labels for all charts by default. If we need it we can enable it in the options for each chart
Chart.defaults.set('plugins.datalabels', {
  display: false,
});

interface LineBarChartProps {
  data: ChartData;
  options: ChartOptions;
  type?: ChartType;
  plugins?: Plugin[];
}

// eslint-disable-next-line arrow-body-style
const LineBarChart: FC<LineBarChartProps> = ({ data, options, type = 'bar', plugins }) => {
  return <ReactChartJs type={type} data={data} options={options} plugins={plugins} />;
};

export default LineBarChart;
